// @ts-nocheck
import { useState } from 'react'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite/no-important'
import dayjs from 'dayjs'
import { Icon } from '../Icon'
import { colors } from '@lmc/common/constants'
import { formatDate, getColor, getIcon, getWitnessName } from './utils'

import videoThumbnailPlaceholder from '../../../images/videoThumbnailPlaceholder.svg'

const LoggedBy = ({ carer }) => {
  if (!carer) return null
  return (
    <span className={css(classes.smallText)} style={{ color: colors.darkgrey }}>
      {carer.name.first} {carer.name.last}
    </span>
  )
}

const LoggedAt = ({ data }) => {
  if (!data) return null
  const originalTimeLog = dayjs(data.originalTimeLog).subtract(15, 'seconds')
  const timeLogged = dayjs(data.timeLogged)
  const dayLogSavedTimedAt = dayjs(data.originalTimeLog).format('D')
  const dayLogChangedTimeAt = dayjs(data.timeLogged).format('D')
  const isSameDay = dayLogChangedTimeAt === dayLogSavedTimedAt

  let logDetailsText = ''
  if (data.originalTimeLog && timeLogged.isBefore(originalTimeLog)) {
    if (isSameDay) {
      logDetailsText = `, logged at: ${dayjs(data.originalTimeLog).format(
        'HH:mm'
      )}`
    } else {
      logDetailsText = `, logged at: ${dayjs(data.originalTimeLog).format(
        'DD/MM/YY HH:mm'
      )}`
    }
  }
  if (data.witnessedBy) {
    logDetailsText += `, witnessed by ${getWitnessName(data.witnessedBy)}`
  }

  if (!logDetailsText) return null
  return (
    <span className={`${css(classes.smallText)} ${css(classes.smallText2)}`}>
      {logDetailsText}
    </span>
  )
}
const Popup = (props) => (
  <div className={css(classes.popupBox)}>
    <div className={css(classes.box)}>
      <span className={css(classes.closeIcon)} onClick={props.handleClose}>
        x
      </span>
      {props.content}
    </div>
  </div>
)

export default function LogSummary({
  data,
  linkEnabled = true,
  logStyle,
  onSelect,
  isLogRemoved,
}) {
  const color = getColor(data)
  const icon = getIcon(data)
  const showEditedBy = data.editedBy && data.editedBy.id && data.editedAt
  const pictures = [data.picture1, data.picture2, data.picture3].filter(
    (p) => p
  )
  const { videoThumbnail, videoFile } = data
  const onClick = () => onSelect(`logs/${data.id}`)
  const opacity = isLogRemoved && 0.2
  const [isVideoOpen, setIsVideoOpen] = useState(false)
  const [isImageOpen, setIsImageOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState('')
  const toggleVideoPopup = () => {
    setIsVideoOpen(!isVideoOpen)
  }
  const toggleImagePopup = () => {
    setIsImageOpen(!isImageOpen)
  }
  return (
    <div
      className={
        logStyle
          ? null
          : linkEnabled
          ? css(classes.logContainer)
          : css(classes.logContainerNoLink)
      }
      onClick={linkEnabled ? onClick : null}
      style={logStyle}
    >
      <div
        className={css(classes.iconContainer)}
        style={{ backgroundColor: isLogRemoved ? colors.grey : color }}
      >
        <img alt="" className={css(classes.icon)} src={icon} />
      </div>
      <div>
        <div className={css(classes.loggedContainer)}>
          <LoggedBy carer={data?.loggedBy} />
          <LoggedAt data={data} />
        </div>
        <span
          className={css(classes.title)}
          style={{ color: isLogRemoved ? colors.darkgrey : null }}
        >
          {isLogRemoved ? 'Log Removed' : data.title}
        </span>
        <span className={css(classes.description)}>
          {!isLogRemoved ? data.description : null}
        </span>
        {showEditedBy && (
          <span
            className={css(classes.smallText)}
            style={{
              color: colors.darkgrey,
              marginTop: 5,
            }}
          >
            {isLogRemoved ? 'Removed by' : 'Edited by'}{' '}
            {data.editedBy.name.first} {data.editedBy.name.last} on{' '}
            {formatDate(data.editedAt)}
          </span>
        )}
        {data.doneBySu && (
          <span className={css(classes.suInvolved)}>
            Service user was involved in writing this log
          </span>
        )}
        {pictures.map((url) => (
          <a
            key={url}
            className="lmc-img__link"
            // href={url}
            // key={url}
            onClick={(e) => {
              e.stopPropagation()
              setSelectedImage(url)
              toggleImagePopup()
            }}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt=""
              className={css(classes.picture)}
              style={{ opacity }}
              src={url}
            />
          </a>
        ))}
        {videoFile && (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            className={css(classes.videoThumbnail)}
            onClick={(e) => {
              e.stopPropagation()
              toggleVideoPopup()
            }}
          >
            <Icon
              name="play"
              fill={colors.white}
              size={32}
              style={{
                position: 'absolute',
                marginTop: 40,
                marginLeft: 20,
              }}
            />
            <img
              alt=""
              className={css(classes.videoThumbnail)}
              src={
                videoThumbnail !== null
                  ? videoThumbnail
                  : videoThumbnailPlaceholder
              }
            />
          </a>
        )}
        {isImageOpen && (
          <Popup
            content={
              <img
                alt=""
                className={css(classes.picturePreview)}
                src={selectedImage}
              />
            }
            handleClose={(e) => {
              toggleImagePopup()
              e.stopPropagation()
            }}
          />
        )}
        {isVideoOpen && (
          <Popup
            content={
              <video controls className={css(classes.video)}>
                <source src={videoFile} type="video/mp4" />
                <track
                  src="captions_en.vtt"
                  kind="captions"
                  label="english_captions"
                />
              </video>
            }
            handleClose={(e) => {
              toggleVideoPopup()
              e.stopPropagation()
            }}
          />
        )}
      </div>
    </div>
  )
}

LogSummary.propTypes = {
  data: PropTypes.object.isRequired,
  isLogRemoved: PropTypes.bool,
  linkEnabled: PropTypes.bool,
  logStyle: PropTypes.object,
  onSelect: PropTypes.func,
}

const classes = StyleSheet.create({
  description: {
    color: colors.black,
    display: 'block',
    marginTop: 2,
  },
  suInvolved: {
    color: '#595959',
    display: 'block',
    marginTop: 2,
    fontSize: '12px',
  },
  icon: {
    width: 20,
  },
  iconContainer: {
    alignItems: 'center',
    borderRadius: 46,
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    height: 46,
    marginRight: 12,
    width: 46,
    alignSelf: 'flex-start',
  },
  picturePreview: {
    maxHeight: '60vh',
    alignSelf: 'center',
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    background: colors.background,
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  logContainer: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    lineHeight: 1.4,
    width: '55%',
  },
  logContainerNoLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 1.4,
    width: '55%',
  },
  picture: {
    height: 100,
    borderRadius: 10,
    marginTop: 8,
    marginRight: 8,
    background: colors.background,
    cursor: 'pointer',
  },
  videoThumbnail: {
    height: 100,
    width: 75,
    borderRadius: 10,
    marginTop: 8,
    marginRight: 8,
    background: colors.background,
    cursor: 'pointer',
  },

  video: {
    width: '100%',
    maxHeight: '60vh',
    borderRadius: 10,
    background: colors.background,
    cursor: 'pointer',
  },
  loggedContainer: {
    display: 'flex',
  },
  smallText: {
    color: colors.darkgrey,
    display: 'block',
    fontSize: 12,
  },
  smallText2: {
    color: colors.darkgrey,
  },
  popupBox: {
    position: 'fixed',
    background: '#00000050',
    width: '100%',
    height: '100vh',
    top: '0',
    left: '0',
    zIndex: 10,
  },
  box: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    width: '70%',
    margin: '0 auto',
    maxHeight: '70vh',
    marginTop: 'calc(100vh - 85vh - 20px)',
    background: colors.white,
    borderRadius: '10px',
    padding: '20px',
    overflow: 'auto',
  },
  iconPlay: {
    position: 'absolute',
    marginTop: 40,
    marginLeft: 20,
  },
  closeIcon: {
    content: "'x'",
    cursor: 'pointer',
    position: 'fixed',
    right: 'calc(15% - 30px)',
    top: 'calc(100vh - 85vh - 33px)',
    background: colors.white,
    width: '25px',
    height: '25px',
    borderRadius: '50%',
    lineHeight: '20px',
    textAlign: 'center',
    fontSize: '20px',
  },
  title: {
    color: colors.black,
    display: 'block',
    fontWeight: 600,
  },
})
